<script lang="ts">
    import cn from 'classnames';
    import { sendLoginEvent } from '$lib/services/gtm/methods';

    import { sendStats } from '@api/user/stats';
    // eslint-disable-next-line no-restricted-imports
    import { globalStore } from '@components/stores';
    import { dialogStore } from '@components/ui/dialog';
    import { LL } from '@i18n/i18n-svelte';
    import { landingPages, URLS } from '@shared/routing';
    import { EventCategory, EventType, SignupContext } from '@shared/types';
    import { Button, ButtonTypes } from '@uikit/button';
    import { IconName } from '@uikit/svg-icon';

    import s from './unauth-buttons.module.css';

    import { page as pageStore } from '$app/stores';

    $: isPage = [URLS.login(), URLS.signup()].includes($pageStore.url.pathname);
    $: isLandingPage = landingPages().includes($pageStore.url.pathname);
    $: geoBlocked = $globalStore.geoBlocked;

    function showLogin(e: Event) {
        sendLoginEvent({ event: EventType.HeaderLoginClick });
        sendStats(EventType.HeaderLoginClick, EventCategory.Login, $globalStore.isDesktopSite);

        if (!isPage) {
            e.preventDefault();
            e.stopPropagation();
            dialogStore.showLogin();
        }
    }

    function showSignup(e: Event) {
        if (!isPage) {
            e.preventDefault();
            e.stopPropagation();
            dialogStore.showSignup({ place: SignupContext.Main });
        }
    }
</script>

{#if $pageStore.url.pathname !== URLS.login()}
    <Button
        href={URLS.login()}
        attrs={{ 'data-testid': 'headerLoginButton' }}
        color={ButtonTypes.Color.Secondary}
        iconRight={IconName.Login}
        classes={cn({ [s.desktop]: $globalStore.isDesktopSite }, s.unauthButton)}
        on:click={showLogin}
    >
        {$LL.auth.login()}
    </Button>
{/if}

{#if $globalStore.isDesktopSite && !isLandingPage && !geoBlocked}
    <Button
        href={URLS.signup()}
        color={ButtonTypes.Color.Brand}
        classes={cn(s.desktop, s.unauthButton)}
        on:click={showSignup}
    >
        {$LL.auth.signupForFree()}
    </Button>
{/if}
